import { StringUtil } from '@/utils/StringUtil';
import _ from 'lodash';
import { defineStore } from 'pinia'

interface OperationSupportState {
  traceId: string, // インスタンス内での操作を追跡するための追跡ID
  device: string | null,
  os: string | null,
  osVersion: string | null,
  appVersion: string | null,
  buildNumber: number | null,
}

export const useOperationSupportStore = defineStore('operation-support', {
  state: (): OperationSupportState => ({
    traceId: StringUtil.generateRandomString(),
    device: null,
    os: null,
    osVersion: null,
    appVersion: null,
    buildNumber: null
  }),
  actions: {

    async setAppInfo(device: string | null, os: string | null, osVersion: string | null, appVersion: string | null, buildNumber: number | null = null) {
      this.device = device ?? null
      this.os = os ?? null
      this.osVersion = osVersion ?? null
      this.appVersion = appVersion ?? null
      this.buildNumber = buildNumber ?? null
    }
  },
  getters: {
  }
})
